/**
 * Defines a custom Webix UI component for displaying a photo.
 */
webix.protoUI(
    {
        /**
         * Component name.
         * @type {string}
         */
        name: 'photo',

        /**
         * Retrieves the current value of the photo component.
         * @returns {string} The current value (photo identifier).
         */
        getValue() {
            return this.config.value;
        },

        /**
         * Sets the value of the photo component and updates the displayed image.
         * @param {string} value - The identifier for the photo to display.
         */
        setValue(value) {
            this.setHTML(
                "<img style='height:260px;' src='data/photos/" + value + "_1.jpg'>", // Sets the HTML to display the image.
            );
            this.config.value = value; // Updates the component's value.
        },
    },
    webix.ui.template, // Inherits from the Webix template UI.
);

// FILE DOCUMENTED
